/** @jsx jsx */

import { PropsWithChildren } from 'react';

import { jsx, css } from '@emotion/core';

import { PartnerProfileProvider } from 'app/developer-v3/hooks';

import Sidebar from './Sidebar';

const Styles = {
  content: css`
    flex: 1;
    height: 100%;
    max-width: 800px;
    overflow-y: auto;
    padding: 25px 40px;
  `,
  root: css`
    display: flex;
    flex: 1;
    height: 100%;
  `,
};

const PartnerSettingsPage = ({ children }: PropsWithChildren<{}>) => {
  return (
    <PartnerProfileProvider>
      <section css={Styles.root}>
        <Sidebar />
        <div css={Styles.content}>{children}</div>
      </section>
    </PartnerProfileProvider>
  );
};

export default PartnerSettingsPage;
